"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Statistic_1 = __importDefault(require("semantic-ui-react/dist/commonjs/views/Statistic"));
var genIcon_1 = __importDefault(require("../../utils/genIcon"));
/* size mapping:
 * - first item - statistic components doesn't have small, medium, large sizes - map s/m/l to sizes statistic has
 * - second item - mapping to the right icon size
 */
var sizes = {
    small: 'tiny',
    medium: 'small',
    large: 'huge'
};
var ARROW = React.createElement(React.Fragment, null, "\u25BE");
function isIn(what, where) {
    return where.indexOf(what) !== -1 ? true : false;
}
/**
 * A Statistic component emphasizes the current value of an attribute.
 */
var Statistic = /** @class */ (function (_super) {
    __extends(Statistic, _super);
    function Statistic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Statistic.prototype.render = function () {
        var _a = this.props, color = _a.color, fluid = _a.fluid, icon = _a.icon, iconPosition = _a.iconPosition, iconRoot = _a.iconRoot, iconRounded = _a.iconRounded, iconSize = _a.iconSize, label = _a.label, labelColor = _a.labelColor, labelIndicator = _a.labelIndicator, subLabel = _a.subLabel, title = _a.title, uom = _a.uom, value = _a.value, cleanedProps = __rest(_a, ["color", "fluid", "icon", "iconPosition", "iconRoot", "iconRounded", "iconSize", "label", "labelColor", "labelIndicator", "subLabel", "title", "uom", "value"]);
        var size = sizes[this.props.size];
        var iconSizeName = sizes[iconSize || this.props.size];
        var vertically = icon && isIn(iconPosition, ['left', 'right']) ? 'vertically ' : '';
        var arrowClass = labelIndicator === 'up' ? 'up-arrow' : '';
        var ico = null;
        if (icon) {
            ico = genIcon_1.default(icon, {
                root: iconRoot,
                className: vertically + (iconRounded ? 'roundedIcon ' : ' ') + iconSizeName
            });
        }
        return (React.createElement(Statistic_1.default, __assign({}, cleanedProps, { size: size, className: this.genClasses() }),
            title && (React.createElement(Statistic_1.default.Label, { className: "title" }, title)),
            React.createElement(Statistic_1.default.Value, { className: vertically },
                icon && isIn(iconPosition, ['top', 'left']) ? ico : null,
                React.createElement("div", { className: vertically + " value " + color },
                    value,
                    uom && React.createElement("span", { className: "uom " + color }, uom)),
                icon && isIn(iconPosition, ['bottom', 'right']) ? ico : null),
            React.createElement(Statistic_1.default.Label, { className: labelColor },
                labelIndicator && (React.createElement("span", { className: "indicator " + arrowClass }, ARROW)),
                label),
            subLabel && (React.createElement(Statistic_1.default.Label, { className: labelColor }, subLabel))));
    };
    Statistic.prototype.genClasses = function () {
        var classes = this.props.className;
        var fluid = this.props.fluid;
        classes += fluid ? ' fluid' : '';
        return classes;
    };
    Statistic.defaultProps = {
        iconPosition: 'top',
        size: 'medium',
        iconRounded: false,
        iconRoot: 'common'
    };
    return Statistic;
}(React.Component));
exports.default = Statistic;
